import LeadKpiFunnelSet from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/indicatoriDiSintesi/IndicatoriDiSintesi.KPIFunnelSet';
import LeadKpiBudgetSet from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/indicatoriDiSintesi/IndicatoriDiSintesi.KPIBudgetSet';

export const graphComponentRegistry = {
    leadKpiFunnelSet: LeadKpiFunnelSet,
    leadKpiBudgetSet: LeadKpiBudgetSet,
};

const withItems = (filters) => ({ items: [...(filters?.items || [])] });
const appendItems = (filters, items) => ({ items: [...(filters?.items || []), ...items] });

export const filtersTransformRegistry = {
    withAcceptedStatus: (filters) => appendItems(filters, [{ field: 'status', operator: 'equals', value: 'accepted' }]),
    leadCostSubset: (filters) => ({
        items: (filters?.items || []).filter(
            (item) =>
                item.field === 'registered_at' ||
                item.field === '_related_source_name' ||
                item.field === '_related_area_name' ||
                item.field === '_related_shop_name',
        ),
    }),
    listingAllAction: (filters) =>
        appendItems(filters, [{ field: 'action', operator: '!=', value: 'start' }]),
    listingChargeAction: (filters) =>
        appendItems(filters, [{ field: 'action', operator: 'in', value: ['charge', 'charge_for_takeover'] }]),
    listingDischargeAction: (filters) =>
        appendItems(filters, [
            {
                field: 'action',
                operator: 'in',
                value: ['discharge_area_change', 'discharge_end_of_employment', 'discharge_end_of_agreement', 'discharge_acceptance'],
            },
        ]),
    listingRebateAction: (filters) =>
        appendItems(filters, [{ field: 'action', operator: 'equals', value: 'rebate' }]),
    identity: (filters) => withItems(filters),
};
